export interface TabPersistenceConfig {
  paramName: string;
  defaultTab?: string;
  updateHistory?: boolean;
}

export const saveSelectedTab = (
  config: TabPersistenceConfig,
  selectedTab: string
): void => {
  try {
    const url = new URL(window.location.href);

    if (selectedTab === config.defaultTab) {
      url.searchParams.delete(config.paramName);
    } else {
      url.searchParams.set(config.paramName, selectedTab);
    }

    if (config.updateHistory) {
      window.history.pushState({}, '', url.toString());
    } else {
      window.history.replaceState({}, '', url.toString());
    }
  } catch (error) {
    console.warn('Failed to save selected tab to URL:', error);
  }
};

export const getSavedTab = (
  config: TabPersistenceConfig
): string | undefined => {
  try {
    const url = new URL(window.location.href);
    const savedTab = url.searchParams.get(config.paramName);

    return savedTab || config.defaultTab;
  } catch (error) {
    console.warn('Failed to retrieve saved tab from URL:', error);
    return config.defaultTab;
  }
};
